// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mt20":"mt20-2VudEpni"};